import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { environment } from '../../environments/environment';
import { AppVersion } from '../entities/app-version';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  appVersion: string;
  appName: string;
  appId: string;
  platforms: string;
  mobileOS: string;
  alert: HTMLIonAlertElement;

  constructor(
    private alertController: AlertController,
    private http: HttpClient,
    private platform: Platform
  ) {
  }

  initialize() {

    this.platform.ready().then(() => {
      if (Capacitor.isNativePlatform()) { //mobile app
        this.platforms = this.platform.platforms().join(', ');
        this.mobileOS = (this.platforms.indexOf('ios') != -1) ? 'iOS' : 'Android';

        this.platform.resume.subscribe(async () => {
          console.log('Resume event detected');
          this.alertIfAppUpdateNeeded();
        });
      }
    });
  }

  alertIfAppUpdateNeeded() {
    console.log('Checking if app update needed...');
    App.getInfo().then(info => {
      this.appId = info.id;
      this.appName = info.name;
      this.appVersion = info.version;
    });

    if (environment.StoreId && this.mobileOS) {
      console.log("getting the min app version...");
      this.getMinimumAppVersion(environment.StoreId, this.mobileOS).subscribe(async minAppVersions => {
        for (let minAppVersion of minAppVersions) {
          if (this.isCurrentVersionSufficient(this.appVersion, minAppVersion.MinVersion)) {
            if (this.alert) { //prevents alerts stacking up
              this.alert.dismiss();
            }

            //show alert
            this.alert = await this.alertController.create({
              header: 'App Update Required',
              message: 'Please update to the latest version in order to contiue using the app.',
              backdropDismiss: false,
              buttons: [
                {
                  text: 'Download',
                  handler: () => {
                    console.log('Download app clicked');
                    if (this.mobileOS == 'Android') {
                      window.open(`https://play.google.com/store/apps/details?id=${this.appId}&hl=en`, "_system");
                    } else { // iOS
                      window.open(`itms-apps://itunes.apple.com/us/app/id${minAppVersion.AppStoreTrackId}?mt=8`, "_system");
                    }
                  }
                }
              ],
            });
            await this.alert.present();
            break; //only present notice once
          };
        }
      });
    }
  }

  getMinimumAppVersion(storeId: number, mobileOS: string) {
    return this.http.get<AppVersion[]>(`${environment.baseApiUrl}MinAppVersion/store/${storeId}/platform/${mobileOS}`, { withCredentials: true });
  }

  isCurrentVersionSufficient(currVersion, minVersion) {
    const currVersionArr = currVersion.split('.')
    const minVersionArr = minVersion.split('.')
    for (var i = 0; i < minVersionArr.length; i++) {
      const minVersionVal = ~~minVersionArr[i] // parse int
      const currVersionVal = ~~currVersionArr[i] // parse int
      if (minVersionVal > currVersionVal)
        return true;
      if (minVersionVal < currVersionVal)
        return false;
    }
    return false;
  }
}
